import { WdioWrapper } from "../../../testing/wdio.js";
import { InputSelectors } from "../Input/input.selectors.js";
const SearchInputSelectors = {
  input: InputSelectors.input,
  iconRight: InputSelectors.iconRight
};
const DsfSearchInputWrapper = (parentSelector) => WdioWrapper(parentSelector, SearchInputSelectors);
export {
  DsfSearchInputWrapper,
  SearchInputSelectors
};
